import Marquee from "react-fast-marquee";
import { useQuery } from "@tanstack/react-query";
import { getScores } from "../lib/api";
import { Link } from "react-router-dom";

export const ScoreMarquee = () => {
  const { data: games = [] } = useQuery({ queryKey: ["scores"], queryFn: getScores, refetchInterval: 60_000 });
  if (!games.length) return null;

  return (
    <div
      data-testid="score-marquee"
      className="bg-secondary border-b-2 border-border h-11 flex items-center overflow-hidden"
    >
      <span className="hidden sm:flex items-center gap-2 px-4 h-full bg-primary text-black font-bold text-xs uppercase tracking-widest shrink-0">
        Week {games[0].week}
      </span>
      <Marquee speed={45} gradient={false} pauseOnHover className="h-full">
        {games.map((g) => (
          <Link
            key={g.id}
            to={`/schedule?week=${g.week}`}
            data-testid={`marquee-game-${g.id}`}
            className="flex items-center gap-3 px-5 h-11 border-r border-border/60 hover:bg-white/5 transition-colors duration-150"
          >
            {g.status === "live" && (
              <span className="flex items-center gap-1 text-accent text-[10px] font-bold uppercase">
                <span className="w-1.5 h-1.5 rounded-full bg-accent live-dot" />
                {g.quarter}
              </span>
            )}
            {g.status === "scheduled" && (
              <span className="text-[10px] font-bold uppercase text-primary">
                {new Date(g.kickoff).toLocaleDateString("en-US", { month: "short", day: "numeric" })}
              </span>
            )}
            {g.status === "final" && (
              <span className="text-[10px] font-bold uppercase text-muted-foreground">Final</span>
            )}
            <span className="flex items-center gap-1.5">
              <img src={g.awayLogo} alt={g.awayTeam} className="w-5 h-5 object-contain" />
              <span className="text-sm font-semibold">{g.awayTeam}</span>
              <span className="font-display text-lg leading-none tabular-nums">{g.awayScore}</span>
            </span>
            <span className="text-muted-foreground text-xs">@</span>
            <span className="flex items-center gap-1.5">
              <img src={g.homeLogo} alt={g.homeTeam} className="w-5 h-5 object-contain" />
              <span className="text-sm font-semibold">{g.homeTeam}</span>
              <span className="font-display text-lg leading-none tabular-nums">{g.homeScore}</span>
            </span>
          </Link>
        ))}
      </Marquee>
    </div>
  );
};
